import React, { useState } from "react";
import { Button, Container, Stack } from "@mui/material";
import { OutletType, getTranslation } from "common";
import { DoingPanel, ToDoPanel, DonePanel } from "components";
import {
  useActivities,
  useSelectedOrganization,
  useTranslations,
  useUser,
} from "hooks";
import { StartProcess } from "components/dialogs";
import {
  DragDropContext,
  OnDragEndResponder,
  OnDragUpdateResponder,
} from "react-beautiful-dnd";
import { filterTasks } from "common/utilities";
import { processesApi } from "api";
import { SequenceFlow, Task } from "model/activitiesModel";
import { useOutletContext } from "react-router";

const MyActivities = () => {
  const translations = useTranslations();
  const organization = useSelectedOrganization();
  const [tasks, setTasks, orderedArray] = useActivities(organization);
  const user = useUser();
  const { firstFilter: searchText } = useOutletContext<OutletType>();
  const [all,] = useState<boolean>(false);
  const [startProcess, setStartProcess] = useState(false);
  const [switchChecked,] = useState(false);
  const [dragItem, setDragItem] = useState<Task | null>(null);
  // const handleSwitchChange = () => {
  //   setSwitchChecked(!switchChecked);
  // };
  const orderArray = (
    source: "todo" | "doing",
    dest: "todo" | "doing",
    sourceIdx: number,
    destIdx: number | null = null
  ) => {
    const _tasks = { ...tasks };
    const [task] = _tasks[source].splice(sourceIdx, 1);
    if (destIdx !== null) {
      task.state = source === "todo" ? 1 : 0;
      _tasks[dest].splice(destIdx, 0, task);
    }
    setTasks(_tasks);
    orderedArray.current = {
      todo: _tasks.todo.map((_) => _.idprocesstoken),
      doing: _tasks.doing.map((_) => _.idprocesstoken),
    };
  };
  const fromTodoTo_Doing = async (task: Task) => {
    try {
      await processesApi.post(`/${task.idprocesstoken}/nextstate/doing`);
    } catch {
    } finally {
      // getTasks(all);
    }
  };
  const fromDoingTo_Done = async (task: Task) => {
    try {
      await processesApi.post(`/${task.idprocesstoken}/nextstate/done`);
    } catch {
    } finally {
      // getTasks(all);
    }
  };
  const fromDoingTo_Todo = async (task: Task) => {
    try {
      await processesApi.post(`/${task.idprocesstoken}/undo`);
    } catch {
    } finally {
      // getTasks(all);
    }
  };
  const fromDoingTo_Sequence = async (
    task: Task,
    sequenceFlow: SequenceFlow
  ) => {
    try {
      await processesApi.post(
        `tokens/${task.idprocesstoken}/exit/${sequenceFlow.designerid}`
      );
    } catch {
    } finally {
      // getTasks(all);
    }
  };
  const handleDragUpdate: OnDragUpdateResponder = ({ destination }) => {
    if (destination && destination.droppableId === "done") {
      setDragItem((_) => {
        if (
          _?.sequenceflows &&
          _?.sequenceflows.length > 0 &&
          destination.index < _.sequenceflows.length
        ) {
          const _sequence = [..._?.sequenceflows].map((_) => ({
            ..._,
            isOver: false,
          }));
          if (_sequence[destination.index]) {
            _sequence[destination.index].isOver = true;
          }
          return {
            ..._,
            isOverDone: false,
            sequenceflows: _sequence,
          };
        }
        return !_
          ? null
          : {
              ..._,
              isOverDone:
                destination.droppableId === "done" && destination.index === 0,
            };
      });
    } else {
      setDragItem((_) => {
        if (_?.sequenceflows && _?.sequenceflows.length > 0) {
          const _sequence = [..._?.sequenceflows].map((_) => ({
            ..._,
            isOver: false,
          }));
          return {
            ..._,
            isOverDone: false,
            sequenceflows: _sequence,
          };
        }
        return !_ ? null : { ..._, isOverDone: false };
      });
    }
  };
  const handleDragEnd: OnDragEndResponder = ({
    reason,
    source,
    destination,
  }) => {
    if (dragItem && destination && reason !== "CANCEL") {
      if (source.droppableId === "doing") {
        if (destination.droppableId === "done") {
          if (dragItem.sequenceflows && dragItem.sequenceflows.length > 0) {
            if (dragItem.sequenceflows.length > destination.index) {
              orderArray("doing", "todo", source.index);
              fromDoingTo_Sequence(
                dragItem,
                dragItem.sequenceflows[destination.index]
              );
            }
          } else {
            orderArray("doing", "todo", source.index);
            fromDoingTo_Done(dragItem);
          }
        } else {
          orderArray("doing", "todo", source.index, destination.index);
          fromDoingTo_Todo(dragItem);
        }
      } else {
        orderArray("todo", "doing", source.index, destination.index);
        fromTodoTo_Doing(dragItem);
      }
    }
    setDragItem(null);
  };
  if (organization && organization.id && user) {
    return (
      <React.Fragment>
        <StartProcess
          isAdmin={organization.administrator}
          open={startProcess}
          setOpen={setStartProcess}
        />
        <DragDropContext
          onDragUpdate={handleDragUpdate}
          onDragEnd={handleDragEnd}
          onBeforeDragStart={(e) => {
            setDragItem(
              tasks[e.source.droppableId as "todo" | "doing"].filter(filterTasks(searchText))[e.source.index]
            );
          }}
        >
          <Stack sx={{ overflow: "hidden" }} height="100%" spacing={1}>
            <Stack direction="row" spacing={2}>
              <Button
                id="startprocess-button"
                size="large"
                variant="semitransparent"
                sx={{
                  mb: 4,
                }}
                onClick={() => setStartProcess(true)}
              >
                {getTranslation(
                  translations,
                  "pm.startprocess.button.ok.caption"
                )}
              </Button>
            </Stack>
            <Stack
              sx={{ overflow: "hidden" }}
              overflow="auto"
              flex={1}
              spacing={2}
            >
              <Stack
                sx={{ overflow: "hidden" }}
                direction="row"
                overflow="auto"
                height="100%"
                spacing={2}
              >
                <Stack
                  sx={{
                    overflow: "hidden",
                    minWidth: 340,
                    width: 340,
                    // pb: 2
                  }}
                  height="100%"
                >
                  {/*
                  <Typography
                    sx={{ flex: 1, textAlign: "center" }}
                    variant="h6"
                  >
                    {getTranslation(
                      translations,
                      "pm.label.process_status.todo"
                    )}
                  </Typography>
                  */}

                  <ToDoPanel
                    goToDoing={fromTodoTo_Doing}
                    filter={searchText}
                    tasks={tasks.todo}
                    dragItem={dragItem}
                    all={all}
                    userId={user.userId}
                    switchChecked={switchChecked}
                    administrator={organization.administrator}
                  />
                </Stack>
                {/* <Divider orientation="vertical" flexItem /> */}
                <Stack
                  sx={{
                    overflow: "hidden",
                    minWidth: 340,
                    width: 340,
                    // pb: 2
                  }}
                  height="100%"
                >
                  {/*
                  <Typography
                    sx={{ flex: 1, textAlign: "center" }}
                    variant="h6"
                  >
                    {getTranslation(
                      translations,
                      "pm.label.process_status.doing"
                    )}
                  </Typography>
                  */}

                  <DoingPanel
                    goToDone={fromDoingTo_Done}
                    goTodo={fromDoingTo_Todo}
                    filter={searchText}
                    handleSequenceFlowChoice={fromDoingTo_Sequence}
                    tasks={tasks.doing}
                    dragItem={dragItem}
                    all={all}
                    userId={user.userId}
                    switchChecked={switchChecked}
                    administrator={organization.administrator}
                  />
                </Stack>
                {/* <Divider orientation="vertical" flexItem /> */}
                <Stack
                  sx={{
                    overflow: "hidden",
                    minWidth: 340,
                    width: 340,
                  }}
                  height="100%"
                >
                  {/*
                    <Typography
                    sx={{ flex: 1, textAlign: "center" }}
                    variant="h6"
                  >
                    {getTranslation(
                      translations,
                      "pm.label.process_status.done"
                    )}
                  </Typography>
                     */}
                  <DonePanel dragItem={dragItem} />
                </Stack>
              </Stack>
            </Stack>
          </Stack>
        </DragDropContext>
      </React.Fragment>
    );
  } else {
    return (
      <Container
        sx={{
          display: "flex",
          JustifyContent: "center",
          alignItems: "center",
        }}
      >
        {getTranslation(translations, "placeholders.organization.select.label")}
      </Container>
    );
  }
};

export default MyActivities;
